import { HttpInterceptorFn } from '@angular/common/http';

export const cleanParamsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.params || req.params.keys().length === 0) {
    return next(req);
  }

  let params = req.params;

  req.params.keys().forEach((key) => {
    const value = params.get(key);

    if (!key || value === null || value === undefined || value === '') {
      params = params.delete(key);
    }
  });

  const cleanedReq = req.clone({ params });
  return next(cleanedReq);
};
